import * as React from 'react';
import * as _ from 'underscore';
import * as $ from 'jquery';

import { IValuesCollection } from '../../ts/appTheme';
import { FormatChooserValueSelector } from './FormatChooserValueSelector';

import { explainAttributeType } from '../../../../_common/platform/ts/Utilities';

import { IFormatChooserValue } from '../FormatChooser';

import { isCountAggregate, IValueFormat } from '../../../../_common/platform/ts/AttrQueryValuesFormat';

import { ATTRIBUTE_TYPES } from '../../ts/ConfigurationConstants';
import SelectField from '../SelectField';
import { ParameterField } from '../ParameterField';

export default function ValueChooser(props: {
    value: IValueFormat;
    formatChooserValue: IFormatChooserValue;
    attributeType: string;
    isScalar: boolean;
    theme: IValuesCollection;

    getDefaultFormat(attributeType: string): string;

    onChange(value: IValueFormat): void;
}) {
    const [attributeType, setAttributeType] = React.useState(() => {
        return props.attributeType === ATTRIBUTE_TYPES.ANYTYPE
            ? props.value?.formatAsType || null
            : props.attributeType;
    });

    if (props.attributeType == null) {
        return null;
    }

    const { formatChooserValue } = props;

    let timePart: string = null;

    if (formatChooserValue.intervals != null) {
        if (formatChooserValue.intervals.timePart != null) {
            timePart = formatChooserValue.intervals.timePart;
        }
    }

    if (timePart == null && formatChooserValue.timePart != null) {
        timePart = formatChooserValue.timePart;
    }

    if (!props.isScalar && timePart == null) {
        return null;
    }

    const isCountAggr = isCountAggregate(formatChooserValue);

    let typeSelector: React.JSX.Element;

    if (props.attributeType === ATTRIBUTE_TYPES.ANYTYPE) {
        const handleOnFormatAsTypeChange = (value: string) => {
            setAttributeType(value);

            const valueCopy = $.extend(true, {}, props.value);

            if (value == null) {
                delete valueCopy.formatAsType;
            } else {
                valueCopy.formatAsType = value;
            }

            valueCopy.formatFront = null;
            valueCopy.precision = null;
            valueCopy.currency = null;
            valueCopy.customFormat = null;
            valueCopy.useDigitGrouping = null;
            valueCopy.overwriteInheritedUseDigitGrouping = null;
            valueCopy.formatZeroAsBlank = null;
            valueCopy.overwriteInheritedFormatZeroAsBlank = null;
            props.onChange(valueCopy);
        };

        typeSelector = (
            <ParameterField title={'Format as Type'} clearable={false}>
                <SelectField
                    value={attributeType}
                    allowNull={true}
                    nullOptionTitle={explainAttributeType(ATTRIBUTE_TYPES.ANYTYPE)}
                    options={{
                        values: [
                            ATTRIBUTE_TYPES.INTEGER,
                            ATTRIBUTE_TYPES.REAL,
                            ATTRIBUTE_TYPES.DATE,
                            ATTRIBUTE_TYPES.DATETIME,
                            ATTRIBUTE_TYPES.BOOLEAN
                        ],
                        display: [
                            explainAttributeType(ATTRIBUTE_TYPES.INTEGER),
                            explainAttributeType(ATTRIBUTE_TYPES.REAL),
                            explainAttributeType(ATTRIBUTE_TYPES.DATE),
                            explainAttributeType(ATTRIBUTE_TYPES.DATETIME),
                            explainAttributeType(ATTRIBUTE_TYPES.BOOLEAN)
                        ]
                    }}
                    onChange={handleOnFormatAsTypeChange}
                />
            </ParameterField>
        );
    }

    return (
        <div>
            <div className="mt-2">
                <ParameterField noTitle={true} clearable={false}>
                    {'Attribute Type: ' +
                        explainAttributeType(props.attributeType) +
                        (timePart != null ? ', timePart: ' + timePart : '')}
                </ParameterField>
            </div>

            {typeSelector}

            <FormatChooserValueSelector
                value={props.value}
                attributeType={attributeType}
                isScalar={props.isScalar}
                timePart={timePart}
                theme={props.theme}
                isCountAggregate={isCountAggr}
                getDefaultFormat={props.getDefaultFormat}
                onChange={props.onChange}
            />
        </div>
    );
}
